import createFetchingHandlers from '../../../utils/createFetchingHandlers';
import createListReducer from '../../../utils/createListReducer';
import actionTypes from '../constants/actionTypes';

const { TRANSACTION_DATA_FETCH, TRANSACTION_DATA_SUCCESS, TRANSACTION_DATA_ERROR } = actionTypes;

const initialState = {
  data: {},
  metadata: {},
};

const fetchingData = createFetchingHandlers([TRANSACTION_DATA_FETCH, TRANSACTION_DATA_SUCCESS, TRANSACTION_DATA_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [TRANSACTION_DATA_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = { ...action?.payload?.data?.transaction };
    return { ...outputState };
  },
};

export default createListReducer(initialState, [fetchingData, getDataHandler]);
